<script>
import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import { isSelectedEventGroupLocked } from '@app/store/eventGroupStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import { createEventDispatcher } from 'svelte';
import * as m from "@app/paraglide/messages.js";
const dispatch = createEventDispatcher();
let isClipboardEventJson = $state(false);
let isLocked = $derived(isSelectedEventGroupLocked());
try {
    navigator.clipboard.readText().then(text => {
        try { 
            let eventJson = JSON.parse(text);
            if (Array.isArray(eventJson) && eventJson[0].id && eventJson[0].xPos && eventJson[0].yPos){
                isClipboardEventJson = true;
            }
        } catch(err){
            // console.log(err.message);
        }
    });
} catch(err){
    console.log(err.message);
}


function openAttributesModal(){
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }
    showModal("pasteAttributes");
    dispatch("done");
}

</script>

<a
    id="pasteAttributesBtn"
    class="dropdown-item {!isClipboardEventJson || isLocked ? 'disabled' : ''}"
    role="button"
    aria-label={m.context_menu_paste_attributes_label()}
    aria-disabled={!isClipboardEventJson || isLocked}
    href="#!/"
    onclick={openAttributesModal}>
    {m.context_menu_paste_attributes()}
</a>